window.TEST_ASSET_DATA = {
  "generatedAt": "2026-06-02T06:58:18+00:00",
  "fabrics": [
    {
      "stoffcode": "4005",
      "name": "Artikelnummer 4005",
      "bild": "./fabrics/4A/4005.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4015",
      "name": "Artikelnummer 4015",
      "bild": "./fabrics/NOS/4015.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4016",
      "name": "Artikelnummer 4016",
      "bild": "./fabrics/NOS/4016.jpeg?v=1780328891",
      "farbe": "silber",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4050",
      "name": "Artikelnummer 4050",
      "bild": "./fabrics/NOS/4050.jpeg?v=1780328891",
      "farbe": "blau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4099",
      "name": "Artikelnummer 4099",
      "bild": "./fabrics/NOS/4099.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4109",
      "name": "Artikelnummer 4109",
      "bild": "./fabrics/NOS/4109.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4121",
      "name": "Artikelnummer 4121",
      "bild": "./fabrics/NOS/4121.jpeg?v=1780328891",
      "farbe": "schwarz",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4122",
      "name": "Artikelnummer 4122",
      "bild": "./fabrics/NOS/4122.jpg?v=1780328891",
      "farbe": "silber",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4123",
      "name": "Artikelnummer 4123",
      "bild": "./fabrics/NOS/4123.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4129",
      "name": "Artikelnummer 4129",
      "bild": "./fabrics/NOS/4129.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4134",
      "name": "Artikelnummer 4134",
      "bild": "./fabrics/NOS/4134.jpeg?v=1780328891",
      "farbe": "silber",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4145",
      "name": "Artikelnummer 4145",
      "bild": "./fabrics/4A/4145.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4147",
      "name": "Artikelnummer 4147",
      "bild": "./fabrics/4A/4147.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4166",
      "name": "Artikelnummer 4166",
      "bild": "./fabrics/NOS/4166.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4169",
      "name": "Artikelnummer 4169",
      "bild": "./fabrics/NOS/4169.jpeg?v=1780328891",
      "farbe": "blau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4170",
      "name": "Artikelnummer 4170",
      "bild": "./fabrics/NOS/4170.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4178",
      "name": "Artikelnummer 4178",
      "bild": "./fabrics/NOS/4178.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4193",
      "name": "Artikelnummer 4193",
      "bild": "./fabrics/4A/4193.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4194",
      "name": "Artikelnummer 4194",
      "bild": "./fabrics/NOS/4194.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4195",
      "name": "Artikelnummer 4195",
      "bild": "./fabrics/NOS/4195.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "NOS"
    },
    {
      "stoffcode": "4197",
      "name": "Artikelnummer 4197",
      "bild": "./fabrics/4A/4197.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4198",
      "name": "Artikelnummer 4198",
      "bild": "./fabrics/4A/4198.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4199",
      "name": "Artikelnummer 4199",
      "bild": "./fabrics/4A/4199.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4900",
      "name": "Artikelnummer 4900",
      "bild": "./fabrics/4A/4900.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4901",
      "name": "Artikelnummer 4901",
      "bild": "./fabrics/4A/4901.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4902",
      "name": "Artikelnummer 4902",
      "bild": "./fabrics/4A/4902.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4903",
      "name": "Artikelnummer 4903",
      "bild": "./fabrics/4A/4903.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4904",
      "name": "Artikelnummer 4904",
      "bild": "./fabrics/4A/4904.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4905",
      "name": "Artikelnummer 4905",
      "bild": "./fabrics/4A/4905.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4906",
      "name": "Artikelnummer 4906",
      "bild": "./fabrics/4A/4906.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "4907",
      "name": "Artikelnummer 4907",
      "bild": "./fabrics/4A/4907.jpeg?v=1780328891",
      "farbe": "grau",
      "muster": "gemustert",
      "kollektion": "4A"
    },
    {
      "stoffcode": "2081",
      "name": "Artikelnummer 2081",
      "bild": "./fabrics/uni01/uni-2081.jpg?v=1783089175",
      "farbe": "bordeaux",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2082",
      "name": "Artikelnummer 2082",
      "bild": "./fabrics/uni01/uni-2082.jpg?v=1783089175",
      "farbe": "aubergine",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2083",
      "name": "Artikelnummer 2083",
      "bild": "./fabrics/uni01/uni-2083.jpg?v=1783089175",
      "farbe": "flieder",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2084",
      "name": "Artikelnummer 2084",
      "bild": "./fabrics/uni01/uni-2084.jpg?v=1783089175",
      "farbe": "mauve",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2086",
      "name": "Artikelnummer 2086",
      "bild": "./fabrics/uni01/uni-2086.jpg?v=1783089175",
      "farbe": "violett",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2087",
      "name": "Artikelnummer 2087",
      "bild": "./fabrics/uni01/uni-2087.jpg?v=1783089175",
      "farbe": "pflaume",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2088",
      "name": "Artikelnummer 2088",
      "bild": "./fabrics/uni01/uni-2088.jpg?v=1783089175",
      "farbe": "hellblau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2090",
      "name": "Artikelnummer 2090",
      "bild": "./fabrics/uni01/uni-2090.jpg?v=1783089175",
      "farbe": "blau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2091",
      "name": "Artikelnummer 2091",
      "bild": "./fabrics/uni01/uni-2091.jpg?v=1783089175",
      "farbe": "petrol",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2092",
      "name": "Artikelnummer 2092",
      "bild": "./fabrics/uni01/uni-2092.jpg?v=1783089175",
      "farbe": "blau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2094",
      "name": "Artikelnummer 2094",
      "bild": "./fabrics/uni01/uni-2094.jpg?v=1783089175",
      "farbe": "dunkelblau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2095",
      "name": "Artikelnummer 2095",
      "bild": "./fabrics/uni01/uni-2095.jpg?v=1783089175",
      "farbe": "marine",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2096",
      "name": "Artikelnummer 2096",
      "bild": "./fabrics/uni01/uni-2096.jpg?v=1783089175",
      "farbe": "anthrazit",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2097",
      "name": "Artikelnummer 2097",
      "bild": "./fabrics/uni01/uni-2097.jpg?v=1783089175",
      "farbe": "anthrazit",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2098",
      "name": "Artikelnummer 2098",
      "bild": "./fabrics/uni01/uni-2098.jpg?v=1783089175",
      "farbe": "schwarz",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2099",
      "name": "Artikelnummer 2099",
      "bild": "./fabrics/uni01/uni-2099.jpg?v=1783089175",
      "farbe": "grau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2100",
      "name": "Artikelnummer 2100",
      "bild": "./fabrics/uni01/uni-2100.jpg?v=1783089175",
      "farbe": "taupe",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2101",
      "name": "Artikelnummer 2101",
      "bild": "./fabrics/uni01/uni-2101.jpg?v=1783089175",
      "farbe": "salbei",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2102",
      "name": "Artikelnummer 2102",
      "bild": "./fabrics/uni01/uni-2102.jpg?v=1783089175",
      "farbe": "olivgrün",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2103",
      "name": "Artikelnummer 2103",
      "bild": "./fabrics/uni01/uni-2103.jpg?v=1783089175",
      "farbe": "olive",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2104",
      "name": "Artikelnummer 2104",
      "bild": "./fabrics/uni01/uni-2104.jpg?v=1783089175",
      "farbe": "khaki",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2105",
      "name": "Artikelnummer 2105",
      "bild": "./fabrics/uni01/uni-2105.jpg?v=1783089175",
      "farbe": "petrol",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2106",
      "name": "Artikelnummer 2106",
      "bild": "./fabrics/uni01/uni-2106.jpg?v=1783089175",
      "farbe": "blau",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2107",
      "name": "Artikelnummer 2107",
      "bild": "./fabrics/uni01/uni-2107.jpg?v=1783089175",
      "farbe": "altrosa",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2108",
      "name": "Artikelnummer 2108",
      "bild": "./fabrics/uni01/uni-2108.jpg?v=1783089175",
      "farbe": "terracotta",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2109",
      "name": "Artikelnummer 2109",
      "bild": "./fabrics/uni01/uni-2109.jpg?v=1783089175",
      "farbe": "braun",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2110",
      "name": "Artikelnummer 2110",
      "bild": "./fabrics/uni01/uni-2110.jpg?v=1783089175",
      "farbe": "rotbraun",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2111",
      "name": "Artikelnummer 2111",
      "bild": "./fabrics/uni01/uni-2111.jpg?v=1783089175",
      "farbe": "dunkelbraun",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2112",
      "name": "Artikelnummer 2112",
      "bild": "./fabrics/uni01/uni-2112.jpg?v=1783089175",
      "farbe": "dunkelgrün",
      "muster": "uni",
      "kollektion": "Uni"
    },
    {
      "stoffcode": "2113",
      "name": "Artikelnummer 2113",
      "bild": "./fabrics/uni01/uni-2113.jpg?v=1783089175",
      "farbe": "schwarzgrün",
      "muster": "uni",
      "kollektion": "Uni"
    }
  ],
  "leatherColors": [
    {
      "id": "schwarz",
      "suffix": "ck",
      "label": "Schwarz",
      "swatch": "./images/hosentraeger/leder/black.png?v=1780328891",
      "hex": "#1a1a1a"
    },
    {
      "id": "cognac",
      "suffix": "br",
      "label": "Cognac",
      "swatch": "./images/hosentraeger/leder/cognac.png?v=1780328891",
      "hex": "#8B5A2B"
    },
    {
      "id": "blau",
      "suffix": "bl",
      "label": "Marine",
      "swatch": "./images/hosentraeger/leder/marine.png?v=1780328891",
      "hex": "#1E3A5F"
    },
    {
      "id": "weiss",
      "suffix": "wh",
      "label": "Weiß",
      "swatch": "./images/hosentraeger/leder/white.png?v=1780328891",
      "hex": "#F5F5F0"
    }
  ],
  "productImages": {
    "fliege": {
      "classic": {
        "basis": "./images/fliege/classic/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/fliege/classic/4A/f-c-4005.jpg?v=1780328891",
          "4145": "./images/fliege/classic/4A/f-c-4145.jpg?v=1780328891",
          "4147": "./images/fliege/classic/4A/f-c-4147.jpg?v=1780328891",
          "4193": "./images/fliege/classic/4A/f-c-4193.jpg?v=1780328891",
          "4197": "./images/fliege/classic/4A/f-c-4197.jpg?v=1780328891",
          "4198": "./images/fliege/classic/4A/f-c-4198.jpg?v=1780328891",
          "4199": "./images/fliege/classic/4A/f-c-4199.jpg?v=1780328891",
          "4900": "./images/fliege/classic/4A/f-c-4900.jpg?v=1780328891",
          "4901": "./images/fliege/classic/4A/f-c-4901.jpg?v=1780328891",
          "4902": "./images/fliege/classic/4A/f-c-4902.jpg?v=1780328891",
          "4903": "./images/fliege/classic/4A/f-c-4903.jpg?v=1780328891",
          "4904": "./images/fliege/classic/4A/f-c-4904.jpg?v=1780328891",
          "4905": "./images/fliege/classic/4A/f-c-4905.jpg?v=1780328891",
          "4906": "./images/fliege/classic/4A/f-c-4906.jpg?v=1780328891",
          "4907": "./images/fliege/classic/4A/f-c-4907.jpg?v=1780328891",
          "4015": "./images/fliege/classic/NOS/f-c-4015.png?v=1780328891",
          "4016": "./images/fliege/classic/NOS/f-c-4016.png?v=1780328891",
          "4050": "./images/fliege/classic/NOS/f-c-4050.png?v=1780328891",
          "4099": "./images/fliege/classic/NOS/f-c-4099.png?v=1780328891",
          "4109": "./images/fliege/classic/NOS/f-c-4109.png?v=1780328891",
          "4121": "./images/fliege/classic/NOS/f-c-4121.png?v=1780328891",
          "4122": "./images/fliege/classic/NOS/f-c-4122.png?v=1780328891",
          "4123": "./images/fliege/classic/NOS/f-c-4123.png?v=1780328891",
          "4129": "./images/fliege/classic/NOS/f-c-4129.png?v=1780328891",
          "4134": "./images/fliege/classic/NOS/f-c-4134.png?v=1780328891",
          "4166": "./images/fliege/classic/NOS/f-c-4166.png?v=1780328891",
          "4169": "./images/fliege/classic/NOS/f-c-4169.png?v=1780328891",
          "4170": "./images/fliege/classic/NOS/f-c-4170.png?v=1780328891",
          "4178": "./images/fliege/classic/NOS/f-c-4178.png?v=1780328891",
          "4194": "./images/fliege/classic/NOS/f-c-4194.png?v=1780328891",
          "4195": "./images/fliege/classic/NOS/f-c-4195.png?v=1780328891",
          "2081": "./images/fliege/classic/Uni01/f-c-2081.jpg?v=1783089175",
          "2082": "./images/fliege/classic/Uni01/f-c-2082.jpg?v=1783089175",
          "2083": "./images/fliege/classic/Uni01/f-c-2083.jpg?v=1783089175",
          "2084": "./images/fliege/classic/Uni01/f-c-2084.jpg?v=1783089175",
          "2086": "./images/fliege/classic/Uni01/f-c-2086.jpg?v=1783089175",
          "2087": "./images/fliege/classic/Uni01/f-c-2087.jpg?v=1783089175",
          "2088": "./images/fliege/classic/Uni01/f-c-2088.jpg?v=1783089175",
          "2090": "./images/fliege/classic/Uni01/f-c-2090.jpg?v=1783089175",
          "2091": "./images/fliege/classic/Uni01/f-c-2091.jpg?v=1783089175",
          "2092": "./images/fliege/classic/Uni01/f-c-2092.jpg?v=1783089175",
          "2094": "./images/fliege/classic/Uni01/f-c-2094.jpg?v=1783089175",
          "2095": "./images/fliege/classic/Uni01/f-c-2095.jpg?v=1783089175",
          "2096": "./images/fliege/classic/Uni01/f-c-2096.jpg?v=1783089175",
          "2097": "./images/fliege/classic/Uni01/f-c-2097.jpg?v=1783089175",
          "2098": "./images/fliege/classic/Uni01/f-c-2098.jpg?v=1783089175",
          "2099": "./images/fliege/classic/Uni01/f-c-2099.jpg?v=1783089175",
          "2100": "./images/fliege/classic/Uni01/f-c-2100.jpg?v=1783089175",
          "2101": "./images/fliege/classic/Uni01/f-c-2101.jpg?v=1783089175",
          "2102": "./images/fliege/classic/Uni01/f-c-2102.jpg?v=1783089175",
          "2103": "./images/fliege/classic/Uni01/f-c-2103.jpg?v=1783089175",
          "2104": "./images/fliege/classic/Uni01/f-c-2104.jpg?v=1783089175",
          "2105": "./images/fliege/classic/Uni01/f-c-2105.jpg?v=1783089175",
          "2106": "./images/fliege/classic/Uni01/f-c-2106.jpg?v=1783089175",
          "2107": "./images/fliege/classic/Uni01/f-c-2107.jpg?v=1783089175",
          "2108": "./images/fliege/classic/Uni01/f-c-2108.jpg?v=1783089175",
          "2109": "./images/fliege/classic/Uni01/f-c-2109.jpg?v=1783089175",
          "2110": "./images/fliege/classic/Uni01/f-c-2110.jpg?v=1783089175",
          "2111": "./images/fliege/classic/Uni01/f-c-2111.jpg?v=1783089175",
          "2112": "./images/fliege/classic/Uni01/f-c-2112.jpg?v=1783089175",
          "2113": "./images/fliege/classic/Uni01/f-c-2113.jpg?v=1783089175"
        }
      },
      "slim": {
        "basis": "./images/fliege/slim/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/fliege/slim/4A/f-s-4005.jpg?v=1780328891",
          "4145": "./images/fliege/slim/4A/f-s-4145.jpg?v=1780328891",
          "4147": "./images/fliege/slim/4A/f-s-4147.jpg?v=1780328891",
          "4193": "./images/fliege/slim/4A/f-s-4193.jpg?v=1780328891",
          "4197": "./images/fliege/slim/4A/f-s-4197.jpg?v=1780328891",
          "4198": "./images/fliege/slim/4A/f-s-4198.jpg?v=1780328891",
          "4199": "./images/fliege/slim/4A/f-s-4199.jpg?v=1780328891",
          "4900": "./images/fliege/slim/4A/f-s-4900.jpg?v=1780328891",
          "4901": "./images/fliege/slim/4A/f-s-4901.jpg?v=1780328891",
          "4902": "./images/fliege/slim/4A/f-s-4902.jpg?v=1780328891",
          "4903": "./images/fliege/slim/4A/f-s-4903.jpg?v=1780328891",
          "4904": "./images/fliege/slim/4A/f-s-4904.jpg?v=1780328891",
          "4905": "./images/fliege/slim/4A/f-s-4905.jpg?v=1780328891",
          "4906": "./images/fliege/slim/4A/f-s-4906.jpg?v=1780328891",
          "4907": "./images/fliege/slim/4A/f-s-4907.jpg?v=1780328891",
          "4015": "./images/fliege/slim/NOS/f-s-4015.png?v=1780328891",
          "4016": "./images/fliege/slim/NOS/f-s-4016.png?v=1780328891",
          "4050": "./images/fliege/slim/NOS/f-s-4050.png?v=1780328891",
          "4099": "./images/fliege/slim/NOS/f-s-4099.png?v=1780328891",
          "4109": "./images/fliege/slim/NOS/f-s-4109.png?v=1780328891",
          "4121": "./images/fliege/slim/NOS/f-s-4121.png?v=1780328891",
          "4122": "./images/fliege/slim/NOS/f-s-4122.png?v=1780328891",
          "4123": "./images/fliege/slim/NOS/f-s-4123.png?v=1780328891",
          "4129": "./images/fliege/slim/NOS/f-s-4129.png?v=1780328891",
          "4134": "./images/fliege/slim/NOS/f-s-4134.png?v=1780328891",
          "4166": "./images/fliege/slim/NOS/f-s-4166.png?v=1780328891",
          "4169": "./images/fliege/slim/NOS/f-s-4169.png?v=1780328891",
          "4170": "./images/fliege/slim/NOS/f-s-4170.png?v=1780328891",
          "4178": "./images/fliege/slim/NOS/f-s-4178.png?v=1780328891",
          "4194": "./images/fliege/slim/NOS/f-s-4194.png?v=1780328891",
          "4195": "./images/fliege/slim/NOS/f-s-4195.png?v=1780328891",
          "2081": "./images/fliege/slim/Uni01/f-s-2081.jpg?v=1783089175",
          "2082": "./images/fliege/slim/Uni01/f-s-2082.jpg?v=1783089175",
          "2083": "./images/fliege/slim/Uni01/f-s-2083.jpg?v=1783089175",
          "2084": "./images/fliege/slim/Uni01/f-s-2084.jpg?v=1783089175",
          "2086": "./images/fliege/slim/Uni01/f-s-2086.jpg?v=1783089175",
          "2087": "./images/fliege/slim/Uni01/f-s-2087.jpg?v=1783089175",
          "2088": "./images/fliege/slim/Uni01/f-s-2088.jpg?v=1783089175",
          "2090": "./images/fliege/slim/Uni01/f-s-2090.jpg?v=1783089175",
          "2091": "./images/fliege/slim/Uni01/f-s-2091.jpg?v=1783089175",
          "2092": "./images/fliege/slim/Uni01/f-s-2092.jpg?v=1783089175",
          "2094": "./images/fliege/slim/Uni01/f-s-2094.jpg?v=1783089175",
          "2095": "./images/fliege/slim/Uni01/f-s-2095.jpg?v=1783089175",
          "2096": "./images/fliege/slim/Uni01/f-s-2096.jpg?v=1783089175",
          "2097": "./images/fliege/slim/Uni01/f-s-2097.jpg?v=1783089175",
          "2098": "./images/fliege/slim/Uni01/f-s-2098.jpg?v=1783089175",
          "2099": "./images/fliege/slim/Uni01/f-s-2099.jpg?v=1783089175",
          "2100": "./images/fliege/slim/Uni01/f-s-2100.jpg?v=1783089175",
          "2101": "./images/fliege/slim/Uni01/f-s-2101.jpg?v=1783089175",
          "2102": "./images/fliege/slim/Uni01/f-s-2102.jpg?v=1783089175",
          "2103": "./images/fliege/slim/Uni01/f-s-2103.jpg?v=1783089175",
          "2104": "./images/fliege/slim/Uni01/f-s-2104.jpg?v=1783089175",
          "2105": "./images/fliege/slim/Uni01/f-s-2105.jpg?v=1783089175",
          "2106": "./images/fliege/slim/Uni01/f-s-2106.jpg?v=1783089175",
          "2107": "./images/fliege/slim/Uni01/f-s-2107.jpg?v=1783089175",
          "2108": "./images/fliege/slim/Uni01/f-s-2108.jpg?v=1783089175",
          "2109": "./images/fliege/slim/Uni01/f-s-2109.jpg?v=1783089175",
          "2110": "./images/fliege/slim/Uni01/f-s-2110.jpg?v=1783089175",
          "2111": "./images/fliege/slim/Uni01/f-s-2111.jpg?v=1783089175",
          "2112": "./images/fliege/slim/Uni01/f-s-2112.jpg?v=1783089175",
          "2113": "./images/fliege/slim/Uni01/f-s-2113.jpg?v=1783089175"
        }
      },
      "standard": {
        "basis": "./images/fliege/standard/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/fliege/standard/4A/f-st-4005.jpg?v=1780328891",
          "4145": "./images/fliege/standard/4A/f-st-4145.jpg?v=1780328891",
          "4147": "./images/fliege/standard/4A/f-st-4147.jpg?v=1780328891",
          "4193": "./images/fliege/standard/4A/f-st-4193.jpg?v=1780328891",
          "4197": "./images/fliege/standard/4A/f-st-4197.jpg?v=1780328891",
          "4198": "./images/fliege/standard/4A/f-st-4198.jpg?v=1780328891",
          "4199": "./images/fliege/standard/4A/f-st-4199.jpg?v=1780328891",
          "4900": "./images/fliege/standard/4A/f-st-4900.jpg?v=1780328891",
          "4901": "./images/fliege/standard/4A/f-st-4901.jpg?v=1780328891",
          "4902": "./images/fliege/standard/4A/f-st-4902.jpg?v=1780328891",
          "4903": "./images/fliege/standard/4A/f-st-4903.jpg?v=1780328891",
          "4904": "./images/fliege/standard/4A/f-st-4904.jpg?v=1780328891",
          "4905": "./images/fliege/standard/4A/f-st-4905.jpg?v=1780328891",
          "4906": "./images/fliege/standard/4A/f-st-4906.jpg?v=1780328891",
          "4907": "./images/fliege/standard/4A/f-st-4907.jpg?v=1780328891",
          "4015": "./images/fliege/standard/NOS/f-st-4015.png?v=1780328891",
          "4016": "./images/fliege/standard/NOS/f-st-4016.png?v=1780328891",
          "4050": "./images/fliege/standard/NOS/f-st-4050.png?v=1780328891",
          "4099": "./images/fliege/standard/NOS/f-st-4099.png?v=1780328891",
          "4109": "./images/fliege/standard/NOS/f-st-4109.png?v=1780328891",
          "4121": "./images/fliege/standard/NOS/f-st-4121.png?v=1780328891",
          "4122": "./images/fliege/standard/NOS/f-st-4122.png?v=1780328891",
          "4123": "./images/fliege/standard/NOS/f-st-4123.png?v=1780328891",
          "4129": "./images/fliege/standard/NOS/f-st-4129.png?v=1780328891",
          "4134": "./images/fliege/standard/NOS/f-st-4134.png?v=1780328891",
          "4166": "./images/fliege/standard/NOS/f-st-4166.png?v=1780328891",
          "4169": "./images/fliege/standard/NOS/f-st-4169.png?v=1780328891",
          "4170": "./images/fliege/standard/NOS/f-st-4170.png?v=1780328891",
          "4178": "./images/fliege/standard/NOS/f-st-4178.png?v=1780328891",
          "4194": "./images/fliege/standard/NOS/f-st-4194.png?v=1780328891",
          "4195": "./images/fliege/standard/NOS/f-st-4195.png?v=1780328891",
          "2081": "./images/fliege/standard/Uni01/f-st-2081.jpg?v=1783089175",
          "2082": "./images/fliege/standard/Uni01/f-st-2082.jpg?v=1783089175",
          "2083": "./images/fliege/standard/Uni01/f-st-2083.jpg?v=1783089175",
          "2084": "./images/fliege/standard/Uni01/f-st-2084.jpg?v=1783089175",
          "2086": "./images/fliege/standard/Uni01/f-st-2086.jpg?v=1783089175",
          "2087": "./images/fliege/standard/Uni01/f-st-2087.jpg?v=1783089175",
          "2088": "./images/fliege/standard/Uni01/f-st-2088.jpg?v=1783089175",
          "2090": "./images/fliege/standard/Uni01/f-st-2090.jpg?v=1783089175",
          "2091": "./images/fliege/standard/Uni01/f-st-2091.jpg?v=1783089175",
          "2092": "./images/fliege/standard/Uni01/f-st-2092.jpg?v=1783089175",
          "2094": "./images/fliege/standard/Uni01/f-st-2094.jpg?v=1783089175",
          "2095": "./images/fliege/standard/Uni01/f-st-2095.jpg?v=1783089175",
          "2096": "./images/fliege/standard/Uni01/f-st-2096.jpg?v=1783089175",
          "2097": "./images/fliege/standard/Uni01/f-st-2097.jpg?v=1783089175",
          "2098": "./images/fliege/standard/Uni01/f-st-2098.jpg?v=1783089175",
          "2099": "./images/fliege/standard/Uni01/f-st-2099.jpg?v=1783089175",
          "2100": "./images/fliege/standard/Uni01/f-st-2100.jpg?v=1783089175",
          "2101": "./images/fliege/standard/Uni01/f-st-2101.jpg?v=1783089175",
          "2102": "./images/fliege/standard/Uni01/f-st-2102.jpg?v=1783089175",
          "2103": "./images/fliege/standard/Uni01/f-st-2103.jpg?v=1783089175",
          "2104": "./images/fliege/standard/Uni01/f-st-2104.jpg?v=1783089175",
          "2105": "./images/fliege/standard/Uni01/f-st-2105.jpg?v=1783089175",
          "2106": "./images/fliege/standard/Uni01/f-st-2106.jpg?v=1783089175",
          "2107": "./images/fliege/standard/Uni01/f-st-2107.jpg?v=1783089175",
          "2108": "./images/fliege/standard/Uni01/f-st-2108.jpg?v=1783089175",
          "2109": "./images/fliege/standard/Uni01/f-st-2109.jpg?v=1783089175",
          "2110": "./images/fliege/standard/Uni01/f-st-2110.jpg?v=1783089175",
          "2111": "./images/fliege/standard/Uni01/f-st-2111.jpg?v=1783089175",
          "2112": "./images/fliege/standard/Uni01/f-st-2112.jpg?v=1783089175",
          "2113": "./images/fliege/standard/Uni01/f-st-2113.jpg?v=1783089175"
        }
      }
    },
    "krawatte": {
      "plastron": {
        "basis": "./images/krawatte/plastron/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/krawatte/plastron/4A/p-4005.jpg?v=1780328891",
          "4145": "./images/krawatte/plastron/4A/p-4145.jpg?v=1780328891",
          "4147": "./images/krawatte/plastron/4A/p-4147.jpg?v=1780328891",
          "4193": "./images/krawatte/plastron/4A/p-4193.jpg?v=1780328891",
          "4197": "./images/krawatte/plastron/4A/p-4197.jpg?v=1780328891",
          "4198": "./images/krawatte/plastron/4A/p-4198.jpg?v=1780328891",
          "4199": "./images/krawatte/plastron/4A/p-4199.jpg?v=1780328891",
          "4900": "./images/krawatte/plastron/4A/p-4900.jpg?v=1780328891",
          "4901": "./images/krawatte/plastron/4A/p-4901.jpg?v=1780328891",
          "4902": "./images/krawatte/plastron/4A/p-4902.jpg?v=1780328891",
          "4903": "./images/krawatte/plastron/4A/p-4903.jpg?v=1780328891",
          "4904": "./images/krawatte/plastron/4A/p-4904.jpg?v=1780328891",
          "4905": "./images/krawatte/plastron/4A/p-4905.jpg?v=1780328891",
          "4906": "./images/krawatte/plastron/4A/p-4906.jpg?v=1780328891",
          "4907": "./images/krawatte/plastron/4A/p-4907.jpg?v=1780328891",
          "4015": "./images/krawatte/plastron/NOS/p-4015.jpg?v=1780328891",
          "4016": "./images/krawatte/plastron/NOS/p-4016.jpg?v=1780328891",
          "4050": "./images/krawatte/plastron/NOS/p-4050.jpg?v=1780328891",
          "4099": "./images/krawatte/plastron/NOS/p-4099.jpg?v=1780328891",
          "4109": "./images/krawatte/plastron/NOS/p-4109.jpg?v=1780328891",
          "4121": "./images/krawatte/plastron/NOS/p-4121.jpg?v=1780328891",
          "4122": "./images/krawatte/plastron/NOS/p-4122.jpg?v=1780328891",
          "4123": "./images/krawatte/plastron/NOS/p-4123.jpg?v=1780328891",
          "4129": "./images/krawatte/plastron/NOS/p-4129.jpg?v=1780328891",
          "4134": "./images/krawatte/plastron/NOS/p-4134.jpg?v=1780328891",
          "4166": "./images/krawatte/plastron/NOS/p-4166.jpg?v=1780328891",
          "4169": "./images/krawatte/plastron/NOS/p-4169.jpg?v=1780328891",
          "4170": "./images/krawatte/plastron/NOS/p-4170.jpg?v=1780328891",
          "4178": "./images/krawatte/plastron/NOS/p-4178.jpg?v=1780328891",
          "4194": "./images/krawatte/plastron/NOS/p-4194.jpg?v=1780328891",
          "4195": "./images/krawatte/plastron/NOS/p-4195.jpg?v=1780328891",
          "2081": "./images/krawatte/plastron/Uni01/p-2081.jpg?v=1783089175",
          "2082": "./images/krawatte/plastron/Uni01/p-2082.jpg?v=1783089175",
          "2083": "./images/krawatte/plastron/Uni01/p-2083.jpg?v=1783089175",
          "2084": "./images/krawatte/plastron/Uni01/p-2084.jpg?v=1783089175",
          "2086": "./images/krawatte/plastron/Uni01/p-2086.jpg?v=1783089175",
          "2087": "./images/krawatte/plastron/Uni01/p-2087.jpg?v=1783089175",
          "2088": "./images/krawatte/plastron/Uni01/p-2088.jpg?v=1783089175",
          "2090": "./images/krawatte/plastron/Uni01/p-2090.jpg?v=1783089175",
          "2091": "./images/krawatte/plastron/Uni01/p-2091.jpg?v=1783089175",
          "2092": "./images/krawatte/plastron/Uni01/p-2092.jpg?v=1783089175",
          "2094": "./images/krawatte/plastron/Uni01/p-2094.jpg?v=1783089175",
          "2095": "./images/krawatte/plastron/Uni01/p-2095.jpg?v=1783089175",
          "2096": "./images/krawatte/plastron/Uni01/p-2096.jpg?v=1783089175",
          "2097": "./images/krawatte/plastron/Uni01/p-2097.jpg?v=1783089175",
          "2098": "./images/krawatte/plastron/Uni01/p-2098.jpg?v=1783089175",
          "2099": "./images/krawatte/plastron/Uni01/p-2099.jpg?v=1783089175",
          "2100": "./images/krawatte/plastron/Uni01/p-2100.jpg?v=1783089175",
          "2101": "./images/krawatte/plastron/Uni01/p-2101.jpg?v=1783089175",
          "2102": "./images/krawatte/plastron/Uni01/p-2102.jpg?v=1783089175",
          "2103": "./images/krawatte/plastron/Uni01/p-2103.jpg?v=1783089175",
          "2104": "./images/krawatte/plastron/Uni01/p-2104.jpg?v=1783089175",
          "2105": "./images/krawatte/plastron/Uni01/p-2105.jpg?v=1783089175",
          "2106": "./images/krawatte/plastron/Uni01/p-2106.jpg?v=1783089175",
          "2107": "./images/krawatte/plastron/Uni01/p-2107.jpg?v=1783089175",
          "2108": "./images/krawatte/plastron/Uni01/p-2108.jpg?v=1783089175",
          "2109": "./images/krawatte/plastron/Uni01/p-2109.jpg?v=1783089175",
          "2110": "./images/krawatte/plastron/Uni01/p-2110.jpg?v=1783089175",
          "2111": "./images/krawatte/plastron/Uni01/p-2111.jpg?v=1783089175",
          "2112": "./images/krawatte/plastron/Uni01/p-2112.jpg?v=1783089175",
          "2113": "./images/krawatte/plastron/Uni01/p-2113.jpg?v=1783089175"
        }
      },
      "slim": {
        "basis": "./images/krawatte/slim/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/krawatte/slim/4A/k-s-4005.jpg?v=1780328891",
          "4145": "./images/krawatte/slim/4A/k-s-4145.jpg?v=1780328891",
          "4147": "./images/krawatte/slim/4A/k-s-4147.jpg?v=1780328891",
          "4193": "./images/krawatte/slim/4A/k-s-4193.jpg?v=1780328891",
          "4197": "./images/krawatte/slim/4A/k-s-4197.jpg?v=1780328891",
          "4198": "./images/krawatte/slim/4A/k-s-4198.jpg?v=1780328891",
          "4199": "./images/krawatte/slim/4A/k-s-4199.jpg?v=1780328891",
          "4900": "./images/krawatte/slim/4A/k-s-4900.jpg?v=1780328891",
          "4901": "./images/krawatte/slim/4A/k-s-4901.jpg?v=1780328891",
          "4902": "./images/krawatte/slim/4A/k-s-4902.jpg?v=1780328891",
          "4903": "./images/krawatte/slim/4A/k-s-4903.jpg?v=1780328891",
          "4904": "./images/krawatte/slim/4A/k-s-4904.jpg?v=1780328891",
          "4905": "./images/krawatte/slim/4A/k-s-4905.jpg?v=1780328891",
          "4906": "./images/krawatte/slim/4A/k-s-4906.jpg?v=1780328891",
          "4907": "./images/krawatte/slim/4A/k-s-4907.jpg?v=1780328891",
          "4015": "./images/krawatte/slim/NOS/k-s-4015.jpg?v=1780328891",
          "4016": "./images/krawatte/slim/NOS/k-s-4016.jpg?v=1780328891",
          "4050": "./images/krawatte/slim/NOS/k-s-4050.jpg?v=1780328891",
          "4099": "./images/krawatte/slim/NOS/k-s-4099.jpg?v=1780328891",
          "4109": "./images/krawatte/slim/NOS/k-s-4109.jpg?v=1780328891",
          "4121": "./images/krawatte/slim/NOS/k-s-4121.jpg?v=1780328891",
          "4122": "./images/krawatte/slim/NOS/k-s-4122.jpg?v=1780328891",
          "4123": "./images/krawatte/slim/NOS/k-s-4123.jpg?v=1780328891",
          "4129": "./images/krawatte/slim/NOS/k-s-4129.jpg?v=1780328891",
          "4134": "./images/krawatte/slim/NOS/k-s-4134.jpg?v=1780328891",
          "4166": "./images/krawatte/slim/NOS/k-s-4166.jpg?v=1780328891",
          "4169": "./images/krawatte/slim/NOS/k-s-4169.jpg?v=1780328891",
          "4170": "./images/krawatte/slim/NOS/k-s-4170.jpg?v=1780328891",
          "4178": "./images/krawatte/slim/NOS/k-s-4178.jpg?v=1780328891",
          "4194": "./images/krawatte/slim/NOS/k-s-4194.jpg?v=1780328891",
          "4195": "./images/krawatte/slim/NOS/k-s-4195.jpg?v=1780328891",
          "2081": "./images/krawatte/slim/Uni01/k-s-2081.jpg?v=1783089175",
          "2082": "./images/krawatte/slim/Uni01/k-s-2082.jpg?v=1783089175",
          "2083": "./images/krawatte/slim/Uni01/k-s-2083.jpg?v=1783089175",
          "2084": "./images/krawatte/slim/Uni01/k-s-2084.jpg?v=1783089175",
          "2086": "./images/krawatte/slim/Uni01/k-s-2086.jpg?v=1783089175",
          "2087": "./images/krawatte/slim/Uni01/k-s-2087.jpg?v=1783089175",
          "2088": "./images/krawatte/slim/Uni01/k-s-2088.jpg?v=1783089175",
          "2090": "./images/krawatte/slim/Uni01/k-s-2090.jpg?v=1783089175",
          "2091": "./images/krawatte/slim/Uni01/k-s-2091.jpg?v=1783089175",
          "2092": "./images/krawatte/slim/Uni01/k-s-2092.jpg?v=1783089175",
          "2094": "./images/krawatte/slim/Uni01/k-s-2094.jpg?v=1783089175",
          "2095": "./images/krawatte/slim/Uni01/k-s-2095.jpg?v=1783089175",
          "2096": "./images/krawatte/slim/Uni01/k-s-2096.jpg?v=1783089175",
          "2097": "./images/krawatte/slim/Uni01/k-s-2097.jpg?v=1783089175",
          "2098": "./images/krawatte/slim/Uni01/k-s-2098.jpg?v=1783089175",
          "2099": "./images/krawatte/slim/Uni01/k-s-2099.jpg?v=1783089175",
          "2100": "./images/krawatte/slim/Uni01/k-s-2100.jpg?v=1783089175",
          "2101": "./images/krawatte/slim/Uni01/k-s-2101.jpg?v=1783089175",
          "2102": "./images/krawatte/slim/Uni01/k-s-2102.jpg?v=1783089175",
          "2103": "./images/krawatte/slim/Uni01/k-s-2103.jpg?v=1783089175",
          "2104": "./images/krawatte/slim/Uni01/k-s-2104.jpg?v=1783089175",
          "2105": "./images/krawatte/slim/Uni01/k-s-2105.jpg?v=1783089175",
          "2106": "./images/krawatte/slim/Uni01/k-s-2106.jpg?v=1783089175",
          "2107": "./images/krawatte/slim/Uni01/k-s-2107.jpg?v=1783089175",
          "2108": "./images/krawatte/slim/Uni01/k-s-2108.jpg?v=1783089175",
          "2109": "./images/krawatte/slim/Uni01/k-s-2109.jpg?v=1783089175",
          "2110": "./images/krawatte/slim/Uni01/k-s-2110.jpg?v=1783089175",
          "2111": "./images/krawatte/slim/Uni01/k-s-2111.jpg?v=1783089175",
          "2112": "./images/krawatte/slim/Uni01/k-s-2112.jpg?v=1783089175",
          "2113": "./images/krawatte/slim/Uni01/k-s-2113.jpg?v=1783089175"
        }
      },
      "standard": {
        "basis": "./images/krawatte/standard/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/krawatte/standard/4A/k-st-4005.jpg?v=1780328891",
          "4145": "./images/krawatte/standard/4A/k-st-4145.jpg?v=1780328891",
          "4147": "./images/krawatte/standard/4A/k-st-4147.jpg?v=1780328891",
          "4193": "./images/krawatte/standard/4A/k-st-4193.jpg?v=1780328891",
          "4197": "./images/krawatte/standard/4A/k-st-4197.jpg?v=1780328891",
          "4198": "./images/krawatte/standard/4A/k-st-4198.jpg?v=1780328891",
          "4199": "./images/krawatte/standard/4A/k-st-4199.jpg?v=1780328891",
          "4900": "./images/krawatte/standard/4A/k-st-4900.jpg?v=1780328891",
          "4901": "./images/krawatte/standard/4A/k-st-4901.jpg?v=1780328891",
          "4902": "./images/krawatte/standard/4A/k-st-4902.jpg?v=1780328891",
          "4903": "./images/krawatte/standard/4A/k-st-4903.jpg?v=1780328891",
          "4904": "./images/krawatte/standard/4A/k-st-4904.jpg?v=1780328891",
          "4905": "./images/krawatte/standard/4A/k-st-4905.jpg?v=1780328891",
          "4906": "./images/krawatte/standard/4A/k-st-4906.jpg?v=1780328891",
          "4907": "./images/krawatte/standard/4A/k-st-4907.jpg?v=1780328891",
          "4015": "./images/krawatte/standard/NOS/k-st-4015.jpg?v=1780328891",
          "4016": "./images/krawatte/standard/NOS/k-st-4016.jpg?v=1780328891",
          "4050": "./images/krawatte/standard/NOS/k-st-4050.jpg?v=1780328891",
          "4099": "./images/krawatte/standard/NOS/k-st-4099.jpg?v=1780328891",
          "4109": "./images/krawatte/standard/NOS/k-st-4109.jpg?v=1780328891",
          "4121": "./images/krawatte/standard/NOS/k-st-4121.jpg?v=1780328891",
          "4122": "./images/krawatte/standard/NOS/k-st-4122.jpg?v=1780328891",
          "4123": "./images/krawatte/standard/NOS/k-st-4123.jpg?v=1780328891",
          "4129": "./images/krawatte/standard/NOS/k-st-4129.jpg?v=1780328891",
          "4134": "./images/krawatte/standard/NOS/k-st-4134.jpg?v=1780328891",
          "4166": "./images/krawatte/standard/NOS/k-st-4166.jpg?v=1780328891",
          "4169": "./images/krawatte/standard/NOS/k-st-4169.jpg?v=1780328891",
          "4170": "./images/krawatte/standard/NOS/k-st-4170.jpg?v=1780328891",
          "4178": "./images/krawatte/standard/NOS/k-st-4178.jpg?v=1780328891",
          "4194": "./images/krawatte/standard/NOS/k-st-4194.jpg?v=1780328891",
          "4195": "./images/krawatte/standard/NOS/k-st-4195.jpg?v=1780328891",
          "2081": "./images/krawatte/standard/Uni01/k-st-2081.jpg?v=1783089175",
          "2082": "./images/krawatte/standard/Uni01/k-st-2082.jpg?v=1783089175",
          "2083": "./images/krawatte/standard/Uni01/k-st-2083.jpg?v=1783089175",
          "2084": "./images/krawatte/standard/Uni01/k-st-2084.jpg?v=1783089175",
          "2086": "./images/krawatte/standard/Uni01/k-st-2086.jpg?v=1783089175",
          "2087": "./images/krawatte/standard/Uni01/k-st-2087.jpg?v=1783089175",
          "2088": "./images/krawatte/standard/Uni01/k-st-2088.jpg?v=1783089175",
          "2090": "./images/krawatte/standard/Uni01/k-st-2090.jpg?v=1783089175",
          "2091": "./images/krawatte/standard/Uni01/k-st-2091.jpg?v=1783089175",
          "2092": "./images/krawatte/standard/Uni01/k-st-2092.jpg?v=1783089175",
          "2094": "./images/krawatte/standard/Uni01/k-st-2094.jpg?v=1783089175",
          "2095": "./images/krawatte/standard/Uni01/k-st-2095.jpg?v=1783089175",
          "2096": "./images/krawatte/standard/Uni01/k-st-2096.jpg?v=1783089175",
          "2097": "./images/krawatte/standard/Uni01/k-st-2097.jpg?v=1783089175",
          "2098": "./images/krawatte/standard/Uni01/k-st-2098.jpg?v=1783089175",
          "2099": "./images/krawatte/standard/Uni01/k-st-2099.jpg?v=1783089175",
          "2100": "./images/krawatte/standard/Uni01/k-st-2100.jpg?v=1783089175",
          "2101": "./images/krawatte/standard/Uni01/k-st-2101.jpg?v=1783089175",
          "2102": "./images/krawatte/standard/Uni01/k-st-2102.jpg?v=1783089175",
          "2103": "./images/krawatte/standard/Uni01/k-st-2103.jpg?v=1783089175",
          "2104": "./images/krawatte/standard/Uni01/k-st-2104.jpg?v=1783089175",
          "2105": "./images/krawatte/standard/Uni01/k-st-2105.jpg?v=1783089175",
          "2106": "./images/krawatte/standard/Uni01/k-st-2106.jpg?v=1783089175",
          "2107": "./images/krawatte/standard/Uni01/k-st-2107.jpg?v=1783089175",
          "2108": "./images/krawatte/standard/Uni01/k-st-2108.jpg?v=1783089175",
          "2109": "./images/krawatte/standard/Uni01/k-st-2109.jpg?v=1783089175",
          "2110": "./images/krawatte/standard/Uni01/k-st-2110.jpg?v=1783089175",
          "2111": "./images/krawatte/standard/Uni01/k-st-2111.jpg?v=1783089175",
          "2112": "./images/krawatte/standard/Uni01/k-st-2112.jpg?v=1783089175",
          "2113": "./images/krawatte/standard/Uni01/k-st-2113.jpg?v=1783089175"
        }
      }
    },
    "hosentraeger": {
      "leder": {
        "basis": "./images/hosentraeger/leder/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/hosentraeger/leder/4A/ht-l-4005-ck.jpg?v=1780328891",
          "4145": "./images/hosentraeger/leder/4A/ht-l-4145-ck.jpg?v=1780328891",
          "4147": "./images/hosentraeger/leder/4A/ht-l-4147-ck.jpg?v=1780328891",
          "4193": "./images/hosentraeger/leder/4A/ht-l-4193-ck.jpg?v=1780328891",
          "4197": "./images/hosentraeger/leder/4A/ht-l-4197-ck.jpg?v=1780328891",
          "4198": "./images/hosentraeger/leder/4A/ht-l-4198-ck.jpg?v=1780328891",
          "4199": "./images/hosentraeger/leder/4A/ht-l-4199-ck.jpg?v=1780328891",
          "4900": "./images/hosentraeger/leder/4A/ht-l-4900-ck.jpg?v=1780328891",
          "4901": "./images/hosentraeger/leder/4A/ht-l-4901-ck.jpg?v=1780328891",
          "4902": "./images/hosentraeger/leder/4A/ht-l-4902-ck.jpg?v=1780328891",
          "4903": "./images/hosentraeger/leder/4A/ht-l-4903-ck.jpg?v=1780328891",
          "4904": "./images/hosentraeger/leder/4A/ht-l-4904-ck.jpg?v=1780328891",
          "4905": "./images/hosentraeger/leder/4A/ht-l-4905-ck.jpg?v=1780328891",
          "4906": "./images/hosentraeger/leder/4A/ht-l-4906-ck.jpg?v=1780328891",
          "4907": "./images/hosentraeger/leder/4A/ht-l-4907-ck.jpg?v=1780328891",
          "4015": "./images/hosentraeger/leder/NOS/ht-l-4015-ck.jpg?v=1780328891",
          "4016": "./images/hosentraeger/leder/NOS/ht-l-4016-ck.jpg?v=1780328891",
          "4050": "./images/hosentraeger/leder/NOS/ht-l-4050-ck.jpg?v=1780328891",
          "4099": "./images/hosentraeger/leder/NOS/ht-l-4099-ck.jpg?v=1780328891",
          "4109": "./images/hosentraeger/leder/NOS/ht-l-4109-ck.jpg?v=1780328891",
          "4121": "./images/hosentraeger/leder/NOS/ht-l-4121-ck.jpg?v=1780328891",
          "4122": "./images/hosentraeger/leder/NOS/ht-l-4122-ck.jpg?v=1780328891",
          "4123": "./images/hosentraeger/leder/NOS/ht-l-4123-ck.jpg?v=1780328891",
          "4129": "./images/hosentraeger/leder/NOS/ht-l-4129-ck.jpg?v=1780328891",
          "4134": "./images/hosentraeger/leder/NOS/ht-l-4134-ck.jpg?v=1780328891",
          "4166": "./images/hosentraeger/leder/NOS/ht-l-4166-ck.jpg?v=1780328891",
          "4169": "./images/hosentraeger/leder/NOS/ht-l-4169-ck.jpg?v=1780328891",
          "4170": "./images/hosentraeger/leder/NOS/ht-l-4170-ck.jpg?v=1780328891",
          "4178": "./images/hosentraeger/leder/NOS/ht-l-4178-ck.jpg?v=1780328891",
          "4194": "./images/hosentraeger/leder/NOS/ht-l-4194-ck.jpg?v=1780328891",
          "4195": "./images/hosentraeger/leder/NOS/ht-l-4195-ck.jpg?v=1780328891",
          "2081": "./images/hosentraeger/leder/Uni01/ht-l-2081-ck.jpg?v=1783089175",
          "2082": "./images/hosentraeger/leder/Uni01/ht-l-2082-ck.jpg?v=1783089175",
          "2083": "./images/hosentraeger/leder/Uni01/ht-l-2083-ck.jpg?v=1783089175",
          "2084": "./images/hosentraeger/leder/Uni01/ht-l-2084-ck.jpg?v=1783089175",
          "2086": "./images/hosentraeger/leder/Uni01/ht-l-2086-ck.jpg?v=1783089175",
          "2087": "./images/hosentraeger/leder/Uni01/ht-l-2087-ck.jpg?v=1783089175",
          "2088": "./images/hosentraeger/leder/Uni01/ht-l-2088-ck.jpg?v=1783089175",
          "2090": "./images/hosentraeger/leder/Uni01/ht-l-2090-ck.jpg?v=1783089175",
          "2091": "./images/hosentraeger/leder/Uni01/ht-l-2091-ck.jpg?v=1783089175",
          "2092": "./images/hosentraeger/leder/Uni01/ht-l-2092-ck.jpg?v=1783089175",
          "2094": "./images/hosentraeger/leder/Uni01/ht-l-2094-ck.jpg?v=1783089175",
          "2095": "./images/hosentraeger/leder/Uni01/ht-l-2095-ck.jpg?v=1783089175",
          "2096": "./images/hosentraeger/leder/Uni01/ht-l-2096-ck.jpg?v=1783089175",
          "2097": "./images/hosentraeger/leder/Uni01/ht-l-2097-ck.jpg?v=1783089175",
          "2098": "./images/hosentraeger/leder/Uni01/ht-l-2098-ck.jpg?v=1783089175",
          "2099": "./images/hosentraeger/leder/Uni01/ht-l-2099-ck.jpg?v=1783089175",
          "2100": "./images/hosentraeger/leder/Uni01/ht-l-2100-ck.jpg?v=1783089175",
          "2101": "./images/hosentraeger/leder/Uni01/ht-l-2101-ck.jpg?v=1783089175",
          "2102": "./images/hosentraeger/leder/Uni01/ht-l-2102-ck.jpg?v=1783089175",
          "2103": "./images/hosentraeger/leder/Uni01/ht-l-2103-ck.jpg?v=1783089175",
          "2104": "./images/hosentraeger/leder/Uni01/ht-l-2104-ck.jpg?v=1783089175",
          "2105": "./images/hosentraeger/leder/Uni01/ht-l-2105-ck.jpg?v=1783089175",
          "2106": "./images/hosentraeger/leder/Uni01/ht-l-2106-ck.jpg?v=1783089175",
          "2107": "./images/hosentraeger/leder/Uni01/ht-l-2107-ck.jpg?v=1783089175",
          "2108": "./images/hosentraeger/leder/Uni01/ht-l-2108-ck.jpg?v=1783089175",
          "2109": "./images/hosentraeger/leder/Uni01/ht-l-2109-ck.jpg?v=1783089175",
          "2110": "./images/hosentraeger/leder/Uni01/ht-l-2110-ck.jpg?v=1783089175",
          "2111": "./images/hosentraeger/leder/Uni01/ht-l-2111-ck.jpg?v=1783089175",
          "2112": "./images/hosentraeger/leder/Uni01/ht-l-2112-ck.jpg?v=1783089175",
          "2113": "./images/hosentraeger/leder/Uni01/ht-l-2113-ck.jpg?v=1783089175"
        },
        "fabricsByColor": {
          "ck": {
            "4005": "./images/hosentraeger/leder/4A/ht-l-4005-ck.jpg?v=1780328891",
            "4145": "./images/hosentraeger/leder/4A/ht-l-4145-ck.jpg?v=1780328891",
            "4147": "./images/hosentraeger/leder/4A/ht-l-4147-ck.jpg?v=1780328891",
            "4193": "./images/hosentraeger/leder/4A/ht-l-4193-ck.jpg?v=1780328891",
            "4197": "./images/hosentraeger/leder/4A/ht-l-4197-ck.jpg?v=1780328891",
            "4198": "./images/hosentraeger/leder/4A/ht-l-4198-ck.jpg?v=1780328891",
            "4199": "./images/hosentraeger/leder/4A/ht-l-4199-ck.jpg?v=1780328891",
            "4900": "./images/hosentraeger/leder/4A/ht-l-4900-ck.jpg?v=1780328891",
            "4901": "./images/hosentraeger/leder/4A/ht-l-4901-ck.jpg?v=1780328891",
            "4902": "./images/hosentraeger/leder/4A/ht-l-4902-ck.jpg?v=1780328891",
            "4903": "./images/hosentraeger/leder/4A/ht-l-4903-ck.jpg?v=1780328891",
            "4904": "./images/hosentraeger/leder/4A/ht-l-4904-ck.jpg?v=1780328891",
            "4905": "./images/hosentraeger/leder/4A/ht-l-4905-ck.jpg?v=1780328891",
            "4906": "./images/hosentraeger/leder/4A/ht-l-4906-ck.jpg?v=1780328891",
            "4907": "./images/hosentraeger/leder/4A/ht-l-4907-ck.jpg?v=1780328891",
            "4015": "./images/hosentraeger/leder/NOS/ht-l-4015-ck.jpg?v=1780328891",
            "4016": "./images/hosentraeger/leder/NOS/ht-l-4016-ck.jpg?v=1780328891",
            "4050": "./images/hosentraeger/leder/NOS/ht-l-4050-ck.jpg?v=1780328891",
            "4099": "./images/hosentraeger/leder/NOS/ht-l-4099-ck.jpg?v=1780328891",
            "4109": "./images/hosentraeger/leder/NOS/ht-l-4109-ck.jpg?v=1780328891",
            "4121": "./images/hosentraeger/leder/NOS/ht-l-4121-ck.jpg?v=1780328891",
            "4122": "./images/hosentraeger/leder/NOS/ht-l-4122-ck.jpg?v=1780328891",
            "4123": "./images/hosentraeger/leder/NOS/ht-l-4123-ck.jpg?v=1780328891",
            "4129": "./images/hosentraeger/leder/NOS/ht-l-4129-ck.jpg?v=1780328891",
            "4134": "./images/hosentraeger/leder/NOS/ht-l-4134-ck.jpg?v=1780328891",
            "4166": "./images/hosentraeger/leder/NOS/ht-l-4166-ck.jpg?v=1780328891",
            "4169": "./images/hosentraeger/leder/NOS/ht-l-4169-ck.jpg?v=1780328891",
            "4170": "./images/hosentraeger/leder/NOS/ht-l-4170-ck.jpg?v=1780328891",
            "4178": "./images/hosentraeger/leder/NOS/ht-l-4178-ck.jpg?v=1780328891",
            "4194": "./images/hosentraeger/leder/NOS/ht-l-4194-ck.jpg?v=1780328891",
            "4195": "./images/hosentraeger/leder/NOS/ht-l-4195-ck.jpg?v=1780328891",
            "2081": "./images/hosentraeger/leder/Uni01/ht-l-2081-ck.jpg?v=1783089175",
            "2082": "./images/hosentraeger/leder/Uni01/ht-l-2082-ck.jpg?v=1783089175",
            "2083": "./images/hosentraeger/leder/Uni01/ht-l-2083-ck.jpg?v=1783089175",
            "2084": "./images/hosentraeger/leder/Uni01/ht-l-2084-ck.jpg?v=1783089175",
            "2086": "./images/hosentraeger/leder/Uni01/ht-l-2086-ck.jpg?v=1783089175",
            "2087": "./images/hosentraeger/leder/Uni01/ht-l-2087-ck.jpg?v=1783089175",
            "2088": "./images/hosentraeger/leder/Uni01/ht-l-2088-ck.jpg?v=1783089175",
            "2090": "./images/hosentraeger/leder/Uni01/ht-l-2090-ck.jpg?v=1783089175",
            "2091": "./images/hosentraeger/leder/Uni01/ht-l-2091-ck.jpg?v=1783089175",
            "2092": "./images/hosentraeger/leder/Uni01/ht-l-2092-ck.jpg?v=1783089175",
            "2094": "./images/hosentraeger/leder/Uni01/ht-l-2094-ck.jpg?v=1783089175",
            "2095": "./images/hosentraeger/leder/Uni01/ht-l-2095-ck.jpg?v=1783089175",
            "2096": "./images/hosentraeger/leder/Uni01/ht-l-2096-ck.jpg?v=1783089175",
            "2097": "./images/hosentraeger/leder/Uni01/ht-l-2097-ck.jpg?v=1783089175",
            "2098": "./images/hosentraeger/leder/Uni01/ht-l-2098-ck.jpg?v=1783089175",
            "2099": "./images/hosentraeger/leder/Uni01/ht-l-2099-ck.jpg?v=1783089175",
            "2100": "./images/hosentraeger/leder/Uni01/ht-l-2100-ck.jpg?v=1783089175",
            "2101": "./images/hosentraeger/leder/Uni01/ht-l-2101-ck.jpg?v=1783089175",
            "2102": "./images/hosentraeger/leder/Uni01/ht-l-2102-ck.jpg?v=1783089175",
            "2103": "./images/hosentraeger/leder/Uni01/ht-l-2103-ck.jpg?v=1783089175",
            "2104": "./images/hosentraeger/leder/Uni01/ht-l-2104-ck.jpg?v=1783089175",
            "2105": "./images/hosentraeger/leder/Uni01/ht-l-2105-ck.jpg?v=1783089175",
            "2106": "./images/hosentraeger/leder/Uni01/ht-l-2106-ck.jpg?v=1783089175",
            "2107": "./images/hosentraeger/leder/Uni01/ht-l-2107-ck.jpg?v=1783089175",
            "2108": "./images/hosentraeger/leder/Uni01/ht-l-2108-ck.jpg?v=1783089175",
            "2109": "./images/hosentraeger/leder/Uni01/ht-l-2109-ck.jpg?v=1783089175",
            "2110": "./images/hosentraeger/leder/Uni01/ht-l-2110-ck.jpg?v=1783089175",
            "2111": "./images/hosentraeger/leder/Uni01/ht-l-2111-ck.jpg?v=1783089175",
            "2112": "./images/hosentraeger/leder/Uni01/ht-l-2112-ck.jpg?v=1783089175",
            "2113": "./images/hosentraeger/leder/Uni01/ht-l-2113-ck.jpg?v=1783089175"
          },
          "br": {
            "4005": "./images/hosentraeger/leder/4A/ht-l-4005-br.jpg?v=1780328891",
            "4145": "./images/hosentraeger/leder/4A/ht-l-4145-br.jpg?v=1780328891",
            "4147": "./images/hosentraeger/leder/4A/ht-l-4147-br.jpg?v=1780328891",
            "4193": "./images/hosentraeger/leder/4A/ht-l-4193-br.jpg?v=1780328891",
            "4197": "./images/hosentraeger/leder/4A/ht-l-4197-br.jpg?v=1780328891",
            "4198": "./images/hosentraeger/leder/4A/ht-l-4198-br.jpg?v=1780328891",
            "4199": "./images/hosentraeger/leder/4A/ht-l-4199-br.jpg?v=1780328891",
            "4900": "./images/hosentraeger/leder/4A/ht-l-4900-br.jpg?v=1780328891",
            "4901": "./images/hosentraeger/leder/4A/ht-l-4901-br.jpg?v=1780328891",
            "4902": "./images/hosentraeger/leder/4A/ht-l-4902-br.jpg?v=1780328891",
            "4903": "./images/hosentraeger/leder/4A/ht-l-4903-br.jpg?v=1780328891",
            "4904": "./images/hosentraeger/leder/4A/ht-l-4904-br.jpg?v=1780328891",
            "4905": "./images/hosentraeger/leder/4A/ht-l-4905-br.jpg?v=1780328891",
            "4906": "./images/hosentraeger/leder/4A/ht-l-4906-br.jpg?v=1780328891",
            "4907": "./images/hosentraeger/leder/4A/ht-l-4907-br.jpg?v=1780328891",
            "4015": "./images/hosentraeger/leder/NOS/ht-l-4015-br.jpg?v=1780328891",
            "4016": "./images/hosentraeger/leder/NOS/ht-l-4016-br.jpg?v=1780328891",
            "4050": "./images/hosentraeger/leder/NOS/ht-l-4050-br.jpg?v=1780328891",
            "4099": "./images/hosentraeger/leder/NOS/ht-l-4099-br.jpg?v=1780328891",
            "4109": "./images/hosentraeger/leder/NOS/ht-l-4109-br.jpg?v=1780328891",
            "4121": "./images/hosentraeger/leder/NOS/ht-l-4121-br.jpg?v=1780328891",
            "4122": "./images/hosentraeger/leder/NOS/ht-l-4122-br.jpg?v=1780328891",
            "4123": "./images/hosentraeger/leder/NOS/ht-l-4123-br.jpg?v=1780328891",
            "4129": "./images/hosentraeger/leder/NOS/ht-l-4129-br.jpg?v=1780328891",
            "4134": "./images/hosentraeger/leder/NOS/ht-l-4134-br.jpg?v=1780328891",
            "4166": "./images/hosentraeger/leder/NOS/ht-l-4166-br.jpg?v=1780328891",
            "4169": "./images/hosentraeger/leder/NOS/ht-l-4169-br.jpg?v=1780328891",
            "4170": "./images/hosentraeger/leder/NOS/ht-l-4170-br.jpg?v=1780328891",
            "4178": "./images/hosentraeger/leder/NOS/ht-l-4178-br.jpg?v=1780328891",
            "4194": "./images/hosentraeger/leder/NOS/ht-l-4194-br.jpg?v=1780328891",
            "4195": "./images/hosentraeger/leder/NOS/ht-l-4195-br.jpg?v=1780328891",
            "2081": "./images/hosentraeger/leder/Uni01/ht-l-2081-br.jpg?v=1783089175",
            "2082": "./images/hosentraeger/leder/Uni01/ht-l-2082-br.jpg?v=1783089175",
            "2083": "./images/hosentraeger/leder/Uni01/ht-l-2083-br.jpg?v=1783089175",
            "2084": "./images/hosentraeger/leder/Uni01/ht-l-2084-br.jpg?v=1783089175",
            "2086": "./images/hosentraeger/leder/Uni01/ht-l-2086-br.jpg?v=1783089175",
            "2087": "./images/hosentraeger/leder/Uni01/ht-l-2087-br.jpg?v=1783089175",
            "2088": "./images/hosentraeger/leder/Uni01/ht-l-2088-br.jpg?v=1783089175",
            "2090": "./images/hosentraeger/leder/Uni01/ht-l-2090-br.jpg?v=1783089175",
            "2091": "./images/hosentraeger/leder/Uni01/ht-l-2091-br.jpg?v=1783089175",
            "2092": "./images/hosentraeger/leder/Uni01/ht-l-2092-br.jpg?v=1783089175",
            "2094": "./images/hosentraeger/leder/Uni01/ht-l-2094-br.jpg?v=1783089175",
            "2095": "./images/hosentraeger/leder/Uni01/ht-l-2095-br.jpg?v=1783089175",
            "2096": "./images/hosentraeger/leder/Uni01/ht-l-2096-br.jpg?v=1783089175",
            "2097": "./images/hosentraeger/leder/Uni01/ht-l-2097-br.jpg?v=1783089175",
            "2098": "./images/hosentraeger/leder/Uni01/ht-l-2098-br.jpg?v=1783089175",
            "2099": "./images/hosentraeger/leder/Uni01/ht-l-2099-br.jpg?v=1783089175",
            "2100": "./images/hosentraeger/leder/Uni01/ht-l-2100-br.jpg?v=1783089175",
            "2101": "./images/hosentraeger/leder/Uni01/ht-l-2101-br.jpg?v=1783089175",
            "2102": "./images/hosentraeger/leder/Uni01/ht-l-2102-br.jpg?v=1783089175",
            "2103": "./images/hosentraeger/leder/Uni01/ht-l-2103-br.jpg?v=1783089175",
            "2104": "./images/hosentraeger/leder/Uni01/ht-l-2104-br.jpg?v=1783089175",
            "2105": "./images/hosentraeger/leder/Uni01/ht-l-2105-br.jpg?v=1783089175",
            "2106": "./images/hosentraeger/leder/Uni01/ht-l-2106-br.jpg?v=1783089175",
            "2107": "./images/hosentraeger/leder/Uni01/ht-l-2107-br.jpg?v=1783089175",
            "2108": "./images/hosentraeger/leder/Uni01/ht-l-2108-br.jpg?v=1783089175",
            "2109": "./images/hosentraeger/leder/Uni01/ht-l-2109-br.jpg?v=1783089175",
            "2110": "./images/hosentraeger/leder/Uni01/ht-l-2110-br.jpg?v=1783089175",
            "2111": "./images/hosentraeger/leder/Uni01/ht-l-2111-br.jpg?v=1783089175",
            "2112": "./images/hosentraeger/leder/Uni01/ht-l-2112-br.jpg?v=1783089175",
            "2113": "./images/hosentraeger/leder/Uni01/ht-l-2113-br.jpg?v=1783089175"
          },
          "bl": {
            "4005": "./images/hosentraeger/leder/4A/ht-l-4005-bl.jpg?v=1780328891",
            "4145": "./images/hosentraeger/leder/4A/ht-l-4145-bl.jpg?v=1780328891",
            "4147": "./images/hosentraeger/leder/4A/ht-l-4147-bl.jpg?v=1780328891",
            "4193": "./images/hosentraeger/leder/4A/ht-l-4193-bl.jpg?v=1780328891",
            "4197": "./images/hosentraeger/leder/4A/ht-l-4197-bl.jpg?v=1780328891",
            "4198": "./images/hosentraeger/leder/4A/ht-l-4198-bl.jpg?v=1780328891",
            "4199": "./images/hosentraeger/leder/4A/ht-l-4199-bl.jpg?v=1780328891",
            "4900": "./images/hosentraeger/leder/4A/ht-l-4900-bl.jpg?v=1780328891",
            "4901": "./images/hosentraeger/leder/4A/ht-l-4901-bl.jpg?v=1780328891",
            "4902": "./images/hosentraeger/leder/4A/ht-l-4902-bl.jpg?v=1780328891",
            "4903": "./images/hosentraeger/leder/4A/ht-l-4903-bl.jpg?v=1780328891",
            "4904": "./images/hosentraeger/leder/4A/ht-l-4904-bl.jpg?v=1780328891",
            "4905": "./images/hosentraeger/leder/4A/ht-l-4905-bl.jpg?v=1780328891",
            "4906": "./images/hosentraeger/leder/4A/ht-l-4906-bl.jpg?v=1780328891",
            "4907": "./images/hosentraeger/leder/4A/ht-l-4907-bl.jpg?v=1780328891",
            "4015": "./images/hosentraeger/leder/NOS/ht-l-4015-bl.jpg?v=1780328891",
            "4016": "./images/hosentraeger/leder/NOS/ht-l-4016-bl.jpg?v=1780328891",
            "4050": "./images/hosentraeger/leder/NOS/ht-l-4050-bl.jpg?v=1780328891",
            "4099": "./images/hosentraeger/leder/NOS/ht-l-4099-bl.jpg?v=1780328891",
            "4109": "./images/hosentraeger/leder/NOS/ht-l-4109-bl.jpg?v=1780328891",
            "4121": "./images/hosentraeger/leder/NOS/ht-l-4121-bl.jpg?v=1780328891",
            "4122": "./images/hosentraeger/leder/NOS/ht-l-4122-bl.jpg?v=1780328891",
            "4123": "./images/hosentraeger/leder/NOS/ht-l-4123-bl.jpg?v=1780328891",
            "4129": "./images/hosentraeger/leder/NOS/ht-l-4129-bl.jpg?v=1780328891",
            "4134": "./images/hosentraeger/leder/NOS/ht-l-4134-bl.jpg?v=1780328891",
            "4166": "./images/hosentraeger/leder/NOS/ht-l-4166-bl.jpg?v=1780328891",
            "4169": "./images/hosentraeger/leder/NOS/ht-l-4169-bl.jpg?v=1780328891",
            "4170": "./images/hosentraeger/leder/NOS/ht-l-4170-bl.jpg?v=1780328891",
            "4178": "./images/hosentraeger/leder/NOS/ht-l-4178-bl.jpg?v=1780328891",
            "4194": "./images/hosentraeger/leder/NOS/ht-l-4194-bl.jpg?v=1780328891",
            "4195": "./images/hosentraeger/leder/NOS/ht-l-4195-bl.jpg?v=1780328891",
            "2081": "./images/hosentraeger/leder/Uni01/ht-l-2081-bl.jpg?v=1783089175",
            "2082": "./images/hosentraeger/leder/Uni01/ht-l-2082-bl.jpg?v=1783089175",
            "2083": "./images/hosentraeger/leder/Uni01/ht-l-2083-bl.jpg?v=1783089175",
            "2084": "./images/hosentraeger/leder/Uni01/ht-l-2084-bl.jpg?v=1783089175",
            "2086": "./images/hosentraeger/leder/Uni01/ht-l-2086-bl.jpg?v=1783089175",
            "2087": "./images/hosentraeger/leder/Uni01/ht-l-2087-bl.jpg?v=1783089175",
            "2088": "./images/hosentraeger/leder/Uni01/ht-l-2088-bl.jpg?v=1783089175",
            "2090": "./images/hosentraeger/leder/Uni01/ht-l-2090-bl.jpg?v=1783089175",
            "2091": "./images/hosentraeger/leder/Uni01/ht-l-2091-bl.jpg?v=1783089175",
            "2092": "./images/hosentraeger/leder/Uni01/ht-l-2092-bl.jpg?v=1783089175",
            "2094": "./images/hosentraeger/leder/Uni01/ht-l-2094-bl.jpg?v=1783089175",
            "2095": "./images/hosentraeger/leder/Uni01/ht-l-2095-bl.jpg?v=1783089175",
            "2096": "./images/hosentraeger/leder/Uni01/ht-l-2096-bl.jpg?v=1783089175",
            "2097": "./images/hosentraeger/leder/Uni01/ht-l-2097-bl.jpg?v=1783089175",
            "2098": "./images/hosentraeger/leder/Uni01/ht-l-2098-bl.jpg?v=1783089175",
            "2099": "./images/hosentraeger/leder/Uni01/ht-l-2099-bl.jpg?v=1783089175",
            "2100": "./images/hosentraeger/leder/Uni01/ht-l-2100-bl.jpg?v=1783089175",
            "2101": "./images/hosentraeger/leder/Uni01/ht-l-2101-bl.jpg?v=1783089175",
            "2102": "./images/hosentraeger/leder/Uni01/ht-l-2102-bl.jpg?v=1783089175",
            "2103": "./images/hosentraeger/leder/Uni01/ht-l-2103-bl.jpg?v=1783089175",
            "2104": "./images/hosentraeger/leder/Uni01/ht-l-2104-bl.jpg?v=1783089175",
            "2105": "./images/hosentraeger/leder/Uni01/ht-l-2105-bl.jpg?v=1783089175",
            "2106": "./images/hosentraeger/leder/Uni01/ht-l-2106-bl.jpg?v=1783089175",
            "2107": "./images/hosentraeger/leder/Uni01/ht-l-2107-bl.jpg?v=1783089175",
            "2108": "./images/hosentraeger/leder/Uni01/ht-l-2108-bl.jpg?v=1783089175",
            "2109": "./images/hosentraeger/leder/Uni01/ht-l-2109-bl.jpg?v=1783089175",
            "2110": "./images/hosentraeger/leder/Uni01/ht-l-2110-bl.jpg?v=1783089175",
            "2111": "./images/hosentraeger/leder/Uni01/ht-l-2111-bl.jpg?v=1783089175",
            "2112": "./images/hosentraeger/leder/Uni01/ht-l-2112-bl.jpg?v=1783089175",
            "2113": "./images/hosentraeger/leder/Uni01/ht-l-2113-bl.jpg?v=1783089175"
          },
          "wh": {
            "4005": "./images/hosentraeger/leder/4A/ht-l-4005-wh.jpg?v=1780328891",
            "4145": "./images/hosentraeger/leder/4A/ht-l-4145-wh.jpg?v=1780328891",
            "4147": "./images/hosentraeger/leder/4A/ht-l-4147-wh.jpg?v=1780328891",
            "4193": "./images/hosentraeger/leder/4A/ht-l-4193-wh.jpg?v=1780328891",
            "4197": "./images/hosentraeger/leder/4A/ht-l-4197-wh.jpg?v=1780328891",
            "4198": "./images/hosentraeger/leder/4A/ht-l-4198-wh.jpg?v=1780328891",
            "4199": "./images/hosentraeger/leder/4A/ht-l-4199-wh.jpg?v=1780328891",
            "4900": "./images/hosentraeger/leder/4A/ht-l-4900-wh.jpg?v=1780328891",
            "4901": "./images/hosentraeger/leder/4A/ht-l-4901-wh.jpg?v=1780328891",
            "4902": "./images/hosentraeger/leder/4A/ht-l-4902-wh.jpg?v=1780328891",
            "4903": "./images/hosentraeger/leder/4A/ht-l-4903-wh.jpg?v=1780328891",
            "4904": "./images/hosentraeger/leder/4A/ht-l-4904-wh.jpg?v=1780328891",
            "4905": "./images/hosentraeger/leder/4A/ht-l-4905-wh.jpg?v=1780328891",
            "4906": "./images/hosentraeger/leder/4A/ht-l-4906-wh.jpg?v=1780328891",
            "4907": "./images/hosentraeger/leder/4A/ht-l-4907-wh.jpg?v=1780328891",
            "4015": "./images/hosentraeger/leder/NOS/ht-l-4015-wh.jpg?v=1780328891",
            "4016": "./images/hosentraeger/leder/NOS/ht-l-4016-wh.jpg?v=1780328891",
            "4050": "./images/hosentraeger/leder/NOS/ht-l-4050-wh.jpg?v=1780328891",
            "4099": "./images/hosentraeger/leder/NOS/ht-l-4099-wh.jpg?v=1780328891",
            "4109": "./images/hosentraeger/leder/NOS/ht-l-4109-wh.jpg?v=1780328891",
            "4121": "./images/hosentraeger/leder/NOS/ht-l-4121-wh.jpg?v=1780328891",
            "4122": "./images/hosentraeger/leder/NOS/ht-l-4122-wh.jpg?v=1780328891",
            "4123": "./images/hosentraeger/leder/NOS/ht-l-4123-wh.jpg?v=1780328891",
            "4129": "./images/hosentraeger/leder/NOS/ht-l-4129-wh.jpg?v=1780328891",
            "4134": "./images/hosentraeger/leder/NOS/ht-l-4134-wh.jpg?v=1780328891",
            "4166": "./images/hosentraeger/leder/NOS/ht-l-4166-wh.jpg?v=1780328891",
            "4169": "./images/hosentraeger/leder/NOS/ht-l-4169-wh.jpg?v=1780328891",
            "4170": "./images/hosentraeger/leder/NOS/ht-l-4170-wh.jpg?v=1780328891",
            "4178": "./images/hosentraeger/leder/NOS/ht-l-4178-wh.jpg?v=1780328891",
            "4194": "./images/hosentraeger/leder/NOS/ht-l-4194-wh.jpg?v=1780328891",
            "4195": "./images/hosentraeger/leder/NOS/ht-l-4195-wh.jpg?v=1780328891",
            "2081": "./images/hosentraeger/leder/Uni01/ht-l-2081-wh.jpg?v=1783089175",
            "2082": "./images/hosentraeger/leder/Uni01/ht-l-2082-wh.jpg?v=1783089175",
            "2083": "./images/hosentraeger/leder/Uni01/ht-l-2083-wh.jpg?v=1783089175",
            "2084": "./images/hosentraeger/leder/Uni01/ht-l-2084-wh.jpg?v=1783089175",
            "2086": "./images/hosentraeger/leder/Uni01/ht-l-2086-wh.jpg?v=1783089175",
            "2087": "./images/hosentraeger/leder/Uni01/ht-l-2087-wh.jpg?v=1783089175",
            "2088": "./images/hosentraeger/leder/Uni01/ht-l-2088-wh.jpg?v=1783089175",
            "2090": "./images/hosentraeger/leder/Uni01/ht-l-2090-wh.jpg?v=1783089175",
            "2091": "./images/hosentraeger/leder/Uni01/ht-l-2091-wh.jpg?v=1783089175",
            "2092": "./images/hosentraeger/leder/Uni01/ht-l-2092-wh.jpg?v=1783089175",
            "2094": "./images/hosentraeger/leder/Uni01/ht-l-2094-wh.jpg?v=1783089175",
            "2095": "./images/hosentraeger/leder/Uni01/ht-l-2095-wh.jpg?v=1783089175",
            "2096": "./images/hosentraeger/leder/Uni01/ht-l-2096-wh.jpg?v=1783089175",
            "2097": "./images/hosentraeger/leder/Uni01/ht-l-2097-wh.jpg?v=1783089175",
            "2098": "./images/hosentraeger/leder/Uni01/ht-l-2098-wh.jpg?v=1783089175",
            "2099": "./images/hosentraeger/leder/Uni01/ht-l-2099-wh.jpg?v=1783089175",
            "2100": "./images/hosentraeger/leder/Uni01/ht-l-2100-wh.jpg?v=1783089175",
            "2101": "./images/hosentraeger/leder/Uni01/ht-l-2101-wh.jpg?v=1783089175",
            "2102": "./images/hosentraeger/leder/Uni01/ht-l-2102-wh.jpg?v=1783089175",
            "2103": "./images/hosentraeger/leder/Uni01/ht-l-2103-wh.jpg?v=1783089175",
            "2104": "./images/hosentraeger/leder/Uni01/ht-l-2104-wh.jpg?v=1783089175",
            "2105": "./images/hosentraeger/leder/Uni01/ht-l-2105-wh.jpg?v=1783089175",
            "2106": "./images/hosentraeger/leder/Uni01/ht-l-2106-wh.jpg?v=1783089175",
            "2107": "./images/hosentraeger/leder/Uni01/ht-l-2107-wh.jpg?v=1783089175",
            "2108": "./images/hosentraeger/leder/Uni01/ht-l-2108-wh.jpg?v=1783089175",
            "2109": "./images/hosentraeger/leder/Uni01/ht-l-2109-wh.jpg?v=1783089175",
            "2110": "./images/hosentraeger/leder/Uni01/ht-l-2110-wh.jpg?v=1783089175",
            "2111": "./images/hosentraeger/leder/Uni01/ht-l-2111-wh.jpg?v=1783089175",
            "2112": "./images/hosentraeger/leder/Uni01/ht-l-2112-wh.jpg?v=1783089175",
            "2113": "./images/hosentraeger/leder/Uni01/ht-l-2113-wh.jpg?v=1783089175"
          }
        }
      },
      "standard": {
        "basis": "./images/hosentraeger/standard/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/hosentraeger/standard/4A/ht-4005.jpg?v=1780328891",
          "4145": "./images/hosentraeger/standard/4A/ht-4145.jpg?v=1780328891",
          "4147": "./images/hosentraeger/standard/4A/ht-4147.jpg?v=1780328891",
          "4193": "./images/hosentraeger/standard/4A/ht-4193.jpg?v=1780328891",
          "4197": "./images/hosentraeger/standard/4A/ht-4197.jpg?v=1780328891",
          "4198": "./images/hosentraeger/standard/4A/ht-4198.jpg?v=1780328891",
          "4199": "./images/hosentraeger/standard/4A/ht-4199.jpg?v=1780328891",
          "4900": "./images/hosentraeger/standard/4A/ht-4900.jpg?v=1780328891",
          "4901": "./images/hosentraeger/standard/4A/ht-4901.jpg?v=1780328891",
          "4902": "./images/hosentraeger/standard/4A/ht-4902.jpg?v=1780328891",
          "4903": "./images/hosentraeger/standard/4A/ht-4903.jpg?v=1780328891",
          "4904": "./images/hosentraeger/standard/4A/ht-4904.jpg?v=1780328891",
          "4905": "./images/hosentraeger/standard/4A/ht-4905.jpg?v=1780328891",
          "4906": "./images/hosentraeger/standard/4A/ht-4906.jpg?v=1780328891",
          "4907": "./images/hosentraeger/standard/4A/ht-4907.jpg?v=1780328891",
          "4015": "./images/hosentraeger/standard/NOS/ht-4015.jpg?v=1780328891",
          "4016": "./images/hosentraeger/standard/NOS/ht-4016.jpg?v=1780328891",
          "4050": "./images/hosentraeger/standard/NOS/ht-4050.jpg?v=1780328891",
          "4099": "./images/hosentraeger/standard/NOS/ht-4099.jpg?v=1780328891",
          "4109": "./images/hosentraeger/standard/NOS/ht-4109.jpg?v=1780328891",
          "4121": "./images/hosentraeger/standard/NOS/ht-4121.jpg?v=1780328891",
          "4122": "./images/hosentraeger/standard/NOS/ht-4122.jpg?v=1780328891",
          "4123": "./images/hosentraeger/standard/NOS/ht-4123.jpg?v=1780328891",
          "4129": "./images/hosentraeger/standard/NOS/ht-4129.jpg?v=1780328891",
          "4134": "./images/hosentraeger/standard/NOS/ht-4134.jpg?v=1780328891",
          "4166": "./images/hosentraeger/standard/NOS/ht-4166.jpg?v=1780328891",
          "4169": "./images/hosentraeger/standard/NOS/ht-4169.jpg?v=1780328891",
          "4170": "./images/hosentraeger/standard/NOS/ht-4170.jpg?v=1780328891",
          "4178": "./images/hosentraeger/standard/NOS/ht-4178.jpg?v=1780328891",
          "4194": "./images/hosentraeger/standard/NOS/ht-4194.jpg?v=1780328891",
          "4195": "./images/hosentraeger/standard/NOS/ht-4195.jpg?v=1780328891",
          "2081": "./images/hosentraeger/standard/Uni01/ht-2081.jpg?v=1783089175",
          "2082": "./images/hosentraeger/standard/Uni01/ht-2082.jpg?v=1783089175",
          "2083": "./images/hosentraeger/standard/Uni01/ht-2083.jpg?v=1783089175",
          "2084": "./images/hosentraeger/standard/Uni01/ht-2084.jpg?v=1783089175",
          "2086": "./images/hosentraeger/standard/Uni01/ht-2086.jpg?v=1783089175",
          "2087": "./images/hosentraeger/standard/Uni01/ht-2087.jpg?v=1783089175",
          "2088": "./images/hosentraeger/standard/Uni01/ht-2088.jpg?v=1783089175",
          "2090": "./images/hosentraeger/standard/Uni01/ht-2090.jpg?v=1783089175",
          "2091": "./images/hosentraeger/standard/Uni01/ht-2091.jpg?v=1783089175",
          "2092": "./images/hosentraeger/standard/Uni01/ht-2092.jpg?v=1783089175",
          "2094": "./images/hosentraeger/standard/Uni01/ht-2094.jpg?v=1783089175",
          "2095": "./images/hosentraeger/standard/Uni01/ht-2095.jpg?v=1783089175",
          "2096": "./images/hosentraeger/standard/Uni01/ht-2096.jpg?v=1783089175",
          "2097": "./images/hosentraeger/standard/Uni01/ht-2097.jpg?v=1783089175",
          "2098": "./images/hosentraeger/standard/Uni01/ht-2098.jpg?v=1783089175",
          "2099": "./images/hosentraeger/standard/Uni01/ht-2099.jpg?v=1783089175",
          "2100": "./images/hosentraeger/standard/Uni01/ht-2100.jpg?v=1783089175",
          "2101": "./images/hosentraeger/standard/Uni01/ht-2101.jpg?v=1783089175",
          "2102": "./images/hosentraeger/standard/Uni01/ht-2102.jpg?v=1783089175",
          "2103": "./images/hosentraeger/standard/Uni01/ht-2103.jpg?v=1783089175",
          "2104": "./images/hosentraeger/standard/Uni01/ht-2104.jpg?v=1783089175",
          "2105": "./images/hosentraeger/standard/Uni01/ht-2105.jpg?v=1783089175",
          "2106": "./images/hosentraeger/standard/Uni01/ht-2106.jpg?v=1783089175",
          "2107": "./images/hosentraeger/standard/Uni01/ht-2107.jpg?v=1783089175",
          "2108": "./images/hosentraeger/standard/Uni01/ht-2108.jpg?v=1783089175",
          "2109": "./images/hosentraeger/standard/Uni01/ht-2109.jpg?v=1783089175",
          "2110": "./images/hosentraeger/standard/Uni01/ht-2110.jpg?v=1783089175",
          "2111": "./images/hosentraeger/standard/Uni01/ht-2111.jpg?v=1783089175",
          "2112": "./images/hosentraeger/standard/Uni01/ht-2112.jpg?v=1783089175",
          "2113": "./images/hosentraeger/standard/Uni01/ht-2113.jpg?v=1783089175"
        }
      }
    },
    "einstecktuch": {
      "standard": {
        "basis": "./images/tuch/basis.png?v=1780328891",
        "fabrics": {
          "4005": "./images/tuch/4A/t-4005.jpg?v=1780328891",
          "4145": "./images/tuch/4A/t-4145.jpg?v=1780328891",
          "4147": "./images/tuch/4A/t-4147.jpg?v=1780328891",
          "4193": "./images/tuch/4A/t-4193.jpg?v=1780328891",
          "4197": "./images/tuch/4A/t-4197.jpg?v=1780328891",
          "4198": "./images/tuch/4A/t-4198.jpg?v=1780328891",
          "4199": "./images/tuch/4A/t-4199.jpg?v=1780328891",
          "4900": "./images/tuch/4A/t-4900.jpg?v=1780328891",
          "4901": "./images/tuch/4A/t-4901.jpg?v=1780328891",
          "4902": "./images/tuch/4A/t-4902.jpg?v=1780328891",
          "4903": "./images/tuch/4A/t-4903.jpg?v=1780328891",
          "4904": "./images/tuch/4A/t-4904.jpg?v=1780328891",
          "4905": "./images/tuch/4A/t-4905.jpg?v=1780328891",
          "4906": "./images/tuch/4A/t-4906.jpg?v=1780328891",
          "4907": "./images/tuch/4A/t-4907.jpg?v=1780328891",
          "4015": "./images/tuch/NOS/t-4015.jpg?v=1780328891",
          "4016": "./images/tuch/NOS/t-4016.jpg?v=1780328891",
          "4050": "./images/tuch/NOS/t-4050.jpg?v=1780328891",
          "4099": "./images/tuch/NOS/t-4099.jpg?v=1780328891",
          "4109": "./images/tuch/NOS/t-4109.jpg?v=1780328891",
          "4121": "./images/tuch/NOS/t-4121.jpg?v=1780328891",
          "4122": "./images/tuch/NOS/t-4122.jpg?v=1780328891",
          "4123": "./images/tuch/NOS/t-4123.jpg?v=1780328891",
          "4129": "./images/tuch/NOS/t-4129.jpg?v=1780328891",
          "4134": "./images/tuch/NOS/t-4134.jpg?v=1780328891",
          "4166": "./images/tuch/NOS/t-4166.jpg?v=1780328891",
          "4169": "./images/tuch/NOS/t-4169.jpg?v=1780328891",
          "4170": "./images/tuch/NOS/t-4170.jpg?v=1780328891",
          "4178": "./images/tuch/NOS/t-4178.jpg?v=1780328891",
          "4194": "./images/tuch/NOS/t-4194.jpg?v=1780328891",
          "4195": "./images/tuch/NOS/t-4195.jpg?v=1780328891",
          "2081": "./images/tuch/Uni01/t-2081.jpg?v=1783089175",
          "2082": "./images/tuch/Uni01/t-2082.jpg?v=1783089175",
          "2083": "./images/tuch/Uni01/t-2083.jpg?v=1783089175",
          "2084": "./images/tuch/Uni01/t-2084.jpg?v=1783089175",
          "2086": "./images/tuch/Uni01/t-2086.jpg?v=1783089175",
          "2087": "./images/tuch/Uni01/t-2087.jpg?v=1783089175",
          "2088": "./images/tuch/Uni01/t-2088.jpg?v=1783089175",
          "2090": "./images/tuch/Uni01/t-2090.jpg?v=1783089175",
          "2091": "./images/tuch/Uni01/t-2091.jpg?v=1783089175",
          "2092": "./images/tuch/Uni01/t-2092.jpg?v=1783089175",
          "2094": "./images/tuch/Uni01/t-2094.jpg?v=1783089175",
          "2095": "./images/tuch/Uni01/t-2095.jpg?v=1783089175",
          "2096": "./images/tuch/Uni01/t-2096.jpg?v=1783089175",
          "2097": "./images/tuch/Uni01/t-2097.jpg?v=1783089175",
          "2098": "./images/tuch/Uni01/t-2098.jpg?v=1783089175",
          "2099": "./images/tuch/Uni01/t-2099.jpg?v=1783089175",
          "2100": "./images/tuch/Uni01/t-2100.jpg?v=1783089175",
          "2101": "./images/tuch/Uni01/t-2101.jpg?v=1783089175",
          "2102": "./images/tuch/Uni01/t-2102.jpg?v=1783089175",
          "2103": "./images/tuch/Uni01/t-2103.jpg?v=1783089175",
          "2104": "./images/tuch/Uni01/t-2104.jpg?v=1783089175",
          "2105": "./images/tuch/Uni01/t-2105.jpg?v=1783089175",
          "2106": "./images/tuch/Uni01/t-2106.jpg?v=1783089175",
          "2107": "./images/tuch/Uni01/t-2107.jpg?v=1783089175",
          "2108": "./images/tuch/Uni01/t-2108.jpg?v=1783089175",
          "2109": "./images/tuch/Uni01/t-2109.jpg?v=1783089175",
          "2110": "./images/tuch/Uni01/t-2110.jpg?v=1783089175",
          "2111": "./images/tuch/Uni01/t-2111.jpg?v=1783089175",
          "2112": "./images/tuch/Uni01/t-2112.jpg?v=1783089175",
          "2113": "./images/tuch/Uni01/t-2113.jpg?v=1783089175"
        }
      }
    }
  }
};
